import apiClient from '../../../api/apiClient';
import { SYSTEM_REST_API_BASE_URL } from '../../../config';
const REST_API_BASE_URL = SYSTEM_REST_API_BASE_URL;

export const getAllGroupsByAccountId = (id) =>
  apiClient.get(`${REST_API_BASE_URL}/account/${id}/groups`);
export const getAllGroupsBySubscriptionId = (id) =>
  apiClient.get(`${REST_API_BASE_URL}/subscription/${id}/groups`);
export const getAllGroupsByMembershipId = (membershipId) =>
  apiClient.get(`${REST_API_BASE_URL}/membership/${membershipId}/groups`);

export const getAllUsersByGroup = (id, groupid) =>
  apiClient.get(`${REST_API_BASE_URL}/account/${id}/group/${groupid}/users`);

export const saveGroupByAccount = (id, group) =>
  apiClient.post(`${REST_API_BASE_URL}/account/${id}/group`, group);

export const getGroup = (id) =>
  apiClient.get(`${REST_API_BASE_URL}/account/${id}/group/${id}`);

export const updateGroup = (id, group) =>
  apiClient.put(`${REST_API_BASE_URL}/group/${id}`, group);

export const deleteGroup = (id) =>
  apiClient.delete(`${REST_API_BASE_URL}/group/${id}`);

export const addUserToGroup = (accid, groupid, userid, user) =>
  apiClient.post(
    `${REST_API_BASE_URL}/account/${accid}/group/${groupid}/user/${userid}`,
    user,
  );

export const removeUserFromGroup = (accid, groupid, userid) =>
  apiClient.delete(
    `${REST_API_BASE_URL}/account/${accid}/group/${groupid}/user/${userid}`,
  );

export default apiClient;
